import { CoverPicture } from './_components/CoverPicture';
import { Discover } from './_components/Discover';

export const Medias = () => {
  return (
    <>
      <CoverPicture />
      <Discover />
    </>
  );
};
